import { render, staticRenderFns } from "./BuyAndSell.vue?vue&type=template&id=5f4c4f16&"
import script from "./BuyAndSell.vue?vue&type=script&lang=ts&"
export * from "./BuyAndSell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports